import { render } from "./NewCheckbox.vue?vue&type=template&id=169590ef&scoped=true"
import script from "./NewCheckbox.vue?vue&type=script&lang=js"
export * from "./NewCheckbox.vue?vue&type=script&lang=js"

import "./NewCheckbox.vue?vue&type=style&index=0&id=169590ef&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169590ef"]])

export default __exports__